import React from 'react'
import { Info, ShieldCheck, Clock, UsersThree } from '@phosphor-icons/react'
import { formatDateTimeFull } from '../../../helpers/formatDate'
import { RBAC_STATUS_COLORS } from '../../components/constants/rbacChipColors'
import {
  RBAC_ROLE_DETAIL_TAB_VALUE,
  RBAC_ROLE_HISTORY_TAB_VALUE,
  RBAC_ROLE_PERMISSIONS_TAB_VALUE,
  RBAC_ROLE_USERS_TAB_VALUE
} from './rbacRoleDetailConstants'

export const RBAC_ROLE_DETAIL_TABS = [
  {
    value: RBAC_ROLE_DETAIL_TAB_VALUE,
    label: 'Detalle',
    icon: <Info size={20} weight="regular" />
  },
  {
    value: RBAC_ROLE_PERMISSIONS_TAB_VALUE,
    label: 'Permisos',
    icon: <ShieldCheck size={20} weight="regular" />
  },
  {
    value: RBAC_ROLE_USERS_TAB_VALUE,
    label: 'Listado de usuarios',
    icon: <UsersThree size={20} weight="regular" />
  },
  {
    value: RBAC_ROLE_HISTORY_TAB_VALUE,
    label: 'Historial',
    icon: <Clock size={20} weight="regular" />
  }
]

export function formatRbacRoleDate(value) {
  return value ? formatDateTimeFull(value) : '—'
}

export function getRbacRoleStatusMeta(role) {
  const normalizedStatus = String(role?.status || '').toLowerCase()

  if (normalizedStatus === 'inactive' || normalizedStatus === 'inactivo') {
    return {
      label: 'INACTIVO',
      isActive: false,
      color: RBAC_STATUS_COLORS.inactive.text,
      backgroundColor: RBAC_STATUS_COLORS.inactive.background
    }
  }

  return {
    label: 'ACTIVO',
    isActive: true,
    color: RBAC_STATUS_COLORS.active.text,
    backgroundColor: RBAC_STATUS_COLORS.active.background
  }
}

export function isRbacRoleActive(role) {
  return getRbacRoleStatusMeta(role).isActive
}

export function getAssignableRbacRoles(roles = [], assignedRoles = []) {
  const assignable = (Array.isArray(roles) ? roles : []).filter(isRbacRoleActive)
  const byId = new Map(assignable.map((role) => [String(role.id), role]))
  const currentAssigned = Array.isArray(assignedRoles) ? assignedRoles : []

  currentAssigned.forEach((role) => {
    if (role?.id == null) return
    const key = String(role.id)
    if (!byId.has(key)) byId.set(key, role)
  })

  return Array.from(byId.values())
}

export function formatRbacRoleCreatedBy(role) {
  const creator = role?.created_by

  if (!creator) return '—'
  if (typeof creator === 'string') return creator

  return creator.name || creator.email || '—'
}

export function getRbacRoleUsersCount(role) {
  return (
    role?.users_count ??
    role?.assigned_users_count ??
    role?.user_count ??
    role?.assigned_users?.length ??
    role?.users?.length ??
    null
  )
}

export function roleHasAssignedUsers(role) {
  const count = getRbacRoleUsersCount(role)
  return Number(count) > 0
}

export function formatRbacRoleUsersCount(role) {
  const count = getRbacRoleUsersCount(role)
  if (count == null) return '—'
  return String(count)
}

export function getRbacRoleCannotInactivateMessage(role) {
  const count = Number(getRbacRoleUsersCount(role)) || 0
  const assignedLabel = count === 1 ? '1 usuario asignado' : `${count} usuarios asignados`

  return (
    <>
      Este rol tiene <strong>{assignedLabel}</strong>. Para inactivarlo, primero reasigna a todos
      sus usuarios a otro rol desde la pestaña Listado de usuarios.
    </>
  )
}
